import {IServiceFactory} from "../../../../service-factory.interface";
import {MealSsrBase} from "../meal-ssr-base";

//Meniu Omleta cu sunca si legume
export default class VlmlSsrType extends MealSsrBase {
    constructor(services: IServiceFactory) {
        super('VLML', services);
    }
}
